import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./SingleAnnouncement.css";

function SingleAnnouncement() {
  const { eventName } = useParams();
  const navigate = useNavigate();
  const decodedName = decodeURIComponent(eventName.replace(/-/g, " "));

  const [announcement, setAnnouncement] = useState(null);
  const [timer, setTimer] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  /* ---------- FETCH ANNOUNCEMENT ---------- */
  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const res = await fetch("https://blog.dietchapter.hosting.acm.org/announcements");
        const data = await res.json();
        const found = data.find((a) => a.title === decodedName);
        setAnnouncement(found || null);
      } catch (err) {
        console.error("Failed to fetch announcement:", err);
      }
    };
    fetchAnnouncement();
  }, [decodedName]);

  /* ---------- COUNTDOWN – FORCED TO Asia/Kolkata (IST) ---------- */
  useEffect(() => {
    if (!announcement?.date) return;

    const startTime = (announcement.time.split("-")[0] || announcement.time).trim();
    const localEventStr = `${announcement.date} ${startTime}`;

    // Parse event time in Asia/Kolkata
    const eventInKolkata = new Date(
      new Intl.DateTimeFormat("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "Asia/Kolkata",
      }).format(new Date(localEventStr + " GMT+0530"))
    ).getTime();

    const interval = setInterval(() => {
      // Current time in Asia/Kolkata
      const nowInKolkata = new Date(
        new Intl.DateTimeFormat("en-CA", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
          timeZone: "Asia/Kolkata",
        }).format(new Date())
      ).getTime();

      const diff = eventInKolkata - nowInKolkata;

      if (diff <= 0) {
        clearInterval(interval);
        setTimer({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimer({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [announcement]);

  /* ---------- NOT FOUND ---------- */
  if (!announcement) {
    return (
      <div className="single-announcement-container">
        <br></br>
        <br></br>
        <br></br>
        <button className="back-btn" onClick={() => navigate(-1)}>
          Back to Announcements
        </button>
        <p className="not-found">Announcement not found.</p>
      </div>
    );
  }

  /* ---------- RENDER ---------- */
  return (
    <div className="single-announcement-container">
      {/* BACK BUTTON */}
      <button className="back-btn" onClick={() => navigate(-1)}>
        Back to Announcements
      </button>

      {/* TITLE + TAGLINE */}
      <h1 className="event-title">{announcement.title}</h1>
      <p className="event-tagline">
        "{announcement.tagline || "Where innovation meets imagination"}"
      </p>

      {/* MAIN GRID: POSTER | DETAILS */}
      <div className="main-grid">
        {/* LEFT: POSTER */}
        <div className="poster-wrapper">
          <img
            src={`https://blog.dietchapter.hosting.acm.org/${announcement.poster}`}
            alt={announcement.title}
            className="event-poster"
          />
        </div>

        {/* RIGHT: DETAILS */}
        <div className="details-wrapper">
          {/* ABOUT */}
          <section className="about-section">
            <h3>About the Event</h3>
            <p>{announcement.fullDescription || announcement.description}</p>
          </section>

          {/* INFO PILLS */}
          <div className="info-pills">
            <div className="pill">
              <span className="pill-label">Date</span>
              <span className="pill-value">{announcement.date}</span>
            </div>
            <div className="pill">
              <span className="pill-label">Time</span>
              <span className="pill-value">{announcement.time}</span>
            </div>
            <div className="pill">
              <span className="pill-label">Location</span>
              <span className="pill-value">{announcement.location}</span>
            </div>
            <div className="pill">
              <span className="pill-label">Organized by</span>
              <span className="pill-value">
                {announcement.organizedBy || "DIET ACM Chapter"}
              </span>
            </div>
          </div>

          {/* COUNTDOWN */}
          <section className="countdown-section">
            <h4>Event Countdown</h4>
            <div className="countdown">
              <div className="time-box">
                <span>{timer.days}</span>
                <small>Days</small>
              </div>
              <div className="time-box">
                <span>{timer.hours}</span>
                <small>Hours</small>
              </div>
              <div className="time-box">
                <span>{timer.minutes}</span>
                <small>Minutes</small>
              </div>
              <div className="time-box">
                <span>{timer.seconds}</span>
                <small>Seconds</small>
              </div>
            </div>
          </section>

          {/* ONLY REGISTER BUTTON */}
          <div className="action-buttons">
            <a
              href={announcement.registrationLink}
              target="_blank"
              rel="noopener noreferrer"
              className="register-btn"
            >
              Register Now
            </a>
          </div>

          {/* REMOVED: Add to Calendar & Share Section */}
        </div>
      </div>
    </div>
  );
}

export default SingleAnnouncement;